(function () {
    'use strict';

    drvTagUsage.$inject = [];
    drvTagUsageCtrl.$inject = [];

    angular
        .module('app')
        .directive('drvTagUsage', drvTagUsage);

    function drvTagUsage() {
        return {
            templateUrl: 'app/Tag/tag-usage.tmpl.html',
            scope: {},
            controller: drvTagUsageCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                linkedItems: '<'
            }
        };
    }

    function drvTagUsageCtrl() {
    }
})();
